import {
  SERVICE_TYPE,
  SERVICE_STATE,
  TGetServicesCollectionItem,
  SERVICE_PLAN,
} from "../../../../api/service/service.types";
import {
  TStaff,
  userCanFollowUpService,
  userCanValueService,
} from "../Staff/Staff";
import moment from "moment";

export const serviceIsSelection = (
  service: TGetServicesCollectionItem
): boolean => {
  return service.Tipo_de_Servicio === SERVICE_TYPE.SELECTION;
};

export const serviceIsCuideoAssist = (
  service: TGetServicesCollectionItem
): boolean => {
  return service.Tipo_de_Servicio === SERVICE_TYPE.CUIDEO_ASIST;
};

export const serviceIsContracted = (
  service: TGetServicesCollectionItem
): boolean => {
  return service.Estado_Servicio === SERVICE_STATE.CLOSED;
};

export const serviceIsValued = (
  service: TGetServicesCollectionItem
): boolean => {
  return service.Estado_Servicio === SERVICE_STATE.VALUED;
};

export const serviceCanBeFollowedUp = (
  service: TGetServicesCollectionItem
): boolean => {
  if (serviceIsContracted(service)) {
    return true;
  }

  return false;
};

export const serviceIsComfortPlus = (service: TGetServicesCollectionItem) => {
  if (
    service.Plan === SERVICE_PLAN.COMFORT_PLUS_IN_PERSON ||
    service.Plan === SERVICE_PLAN.COMFORT_PLUS_PHONE
  ) {
    return true;
  }

  return false;
};

export const serviceIsComfort = (service: TGetServicesCollectionItem) => {
  if (service.Plan === SERVICE_PLAN.COMFORT) {
    return true;
  }
};

export const serviceIsPunctualService = (
  service: TGetServicesCollectionItem
) => {
  if (service.Plan === SERVICE_PLAN.PUNCTUAL_SELECTION) {
    return true;
  }
};

export const serviceIsExpress = (service: TGetServicesCollectionItem) => {
  return service.Servicio_Express === true;
};

export const serviceCanBeFollowedByUser = (
  service: TGetServicesCollectionItem,
  user: TStaff
): boolean => {
  if (serviceIsContracted(service)) {
    if (userCanFollowUpService(user)) {
      if (
        serviceHasNeverBeenFollowedUp(service) &&
        serviceHasBeenActiveAtLeastDaysAgo(service, 15)
      ) {
        return true;
      }
    }
  }

  return false;
};

export const serviceCanBeValuedByUser = (
  service: TGetServicesCollectionItem,
  user: TStaff
): boolean => {
  if (serviceIsContracted(service) || serviceIsValued(service)) {
    if (userCanValueService(user)) {
      return true;
    }
  }

  return false;
};

export const serviceHasNeverBeenFollowedUp = (
  service: TGetServicesCollectionItem
): boolean => {
  if (service.Seguimiento_datetime) {
    return false;
  }

  return true;
};

export const serviceHasBeenActiveAtLeastDaysAgo = (
  service: TGetServicesCollectionItem,
  daysAgo: number
): boolean => {
  const xDaysAgo = moment().subtract(daysAgo, "days");
  const serviceContractedDate = moment(service.Cerrado_Contratadodate);
  if (serviceContractedDate.isBefore(xDaysAgo)) {
    return true;
  }

  return false;
};

export const serviceCanBeDelayed = (
  service: TGetServicesCollectionItem
): boolean => {
  return service.Estado_Servicio === SERVICE_STATE.WITHOUT_VALIDATION;
};
